import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { IoDocuments } from 'react-icons/io5';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import {
    fetchWrapper,
    getChannelIdFromSettingsURL,
    getStandardDate,
    getTeamIdFromURL,
    SafeJSONParse,
} from '../../../../../_helpers';
import { VscLoading } from 'react-icons/vsc';
import styled from '@emotion/styled';
import SubmissionViewer from './SubmissionViewer';
import { connect } from 'react-redux';
const StyledModalDialog = styled.div`
    &.modal-90w {
        width: 90%;
        max-width: none !important;
        background: #fff;
        margin: auto;
    }
`;
// const groupByDate = (data) => {
//     const res = [{ sticky: true, value: 'day' }];
//     const dates = {};

//     (data || []).forEach((item) => {
//         if (item?.createdAt) {
//             const value = dayjs(item.createdAt).format('MMMM D, YYYY') + ':';
//             if (!dates[value]) {
//                 dates[value] = value;
//                 res.push({ value, day: true });
//             } else {
//                 res.push({ value: '' });
//             }
//         }
//     });

//     return { values: res };
// };

function AccumulatedView({ form, sortBy, channel, startDate, endDate, user, teams }) {
    const channelIdFromUrl = getChannelIdFromSettingsURL();
    const teamId = getTeamIdFromURL();
    const teamInfo = useMemo(() => {
        const name = (teams || []).find((team) => (team?._id || team?.id) === teamId)?.name || '';
        return {
            name,
            teamId,
        };
    }, [teams, teamId]);

    const [tables, setTables] = useState([]);
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const isFormSelected = useMemo(() => !!(form && (!Array.isArray(form) || form.length)), [form]);

    const fetchData = async () => {
        try {
            setLoading(true);
            setTables([]);
            let url = `userFormData?sortBy=createdAt:asc&limit=3000&page=1`;

            if (!form || (Array.isArray(form) && form.length === 0)) {
                return;
            }

            if (Array.isArray(form)) {
                url += `&forms=${form.map((f) => f.value).join(',')}`;
            } else {
                url += `&form=${form.value}`;
            }

            if (user?.value) {
                url += `&user=${user.value}`;
            }
            if (channel?.value || channelIdFromUrl) {
                url += `&chatroom=${channelIdFromUrl || channel?.value}`;
            } else if (teamId) {
                url += `&team=${teamId}`;
            }
            if (startDate) {
                url += `&startDate=${startDate}`;
            }
            if (endDate) {
                url += `&endDate=${endDate}`;
            }

            const response = await fetchWrapper.get(url);
            if (response) {
                const { results = [] } = response;

                // Group results by form if multiple forms
                const groupedResults = Array.isArray(form)
                    ? form.map((f) => results.filter((r) => r.form === f.value))
                    : [results];

                const allFormsOutput = [];

                groupedResults.forEach((formResults, formIndex) => {
                    if (!formResults.length) return;

                    const currentForm = Array.isArray(form) ? form[formIndex] : form;
                    const fields = [
                        { fieldName: 'Submitted Date', sticky: true },
                        { fieldName: 'Submitted Time', sticky: true },
                        { fieldName: 'Submitted By', sticky: true },
                    ];
                    const data = [];

                    // Derive all field headers from the first entry
                    const formFields = (formResults[0]?.formData?.data || []).filter((f) => f.key !== 'Header');
                    formFields.forEach((f) => fields.push({ fieldName: f.fieldName }));

                    // Build each row (one row per submission)
                    formResults.forEach(({ userData, createdAt, data: userFormData }) => {
                        const row = [];
                        // row.push({ value: dayjs(createdAt).format('MMMM D, YYYY'), sticky: true });
                        row.push({ value: getStandardDate(createdAt), sticky: true });
                        // Submitted At
                        row.push({ value: dayjs(createdAt).format('h:mm A'), sticky: true });
                        // Submitted By
                        row.push({ value: userData?.name || 'Deleted User', sticky: true });

                        formFields.forEach((field) => {
                            const { key: fieldType, _id, data: fieldData } = field;
                            const matchedField = userFormData?.find((f) => _id === f.fieldName.split('-')[1]);
                            const userDataValue = matchedField?.value;

                            const actualValue = fieldData?.find((f) => f?.value === userDataValue)?.text;
                            let image;
                            let value = actualValue || matchedField?.text || userDataValue || '';
                            if ((field?.options || {})?.enableDataValue) {
                                value = fieldData?.find((f) => f?.value === userDataValue)?.dataValue || value;
                            }

                            try {
                                switch (fieldType) {
                                    case 'FullName':
                                        const fullName = JSON.parse(value);
                                        value = `${fullName?.firstName || ''} ${fullName?.lastName || ''}`;
                                        break;
                                    case 'Signature':
                                    case 'Image':
                                        image = value;
                                        value = undefined;
                                        break;
                                    case 'Checkbox':
                                        const parsed = SafeJSONParse(value) || [];
                                        if ((field?.options || {})?.enableDataValue) {
                                            value = parsed
                                                .map((v) => fieldData?.find((f) => f?.value === v)?.dataValue)
                                                .join(', ');
                                        } else {
                                            value = parsed
                                                .map((v) => fieldData?.find((f) => f?.value === v)?.text)
                                                .join(', ');
                                        }
                                        break;
                                    case 'ServiceRadio':
                                        value = SafeJSONParse(value)?.HCPCS || value;
                                        break;
                                    default:
                                        if (fieldType.toLowerCase().includes('date')) {
                                            value = dayjs(value).format('MMMM D, YYYY h:mm A');
                                        } else if (fieldType.toLowerCase().includes('time')) {
                                            value = dayjs(value).format('h:mm A');
                                        }
                                        break;
                                }
                            } catch (e) {
                                console.error(e);
                            }

                            row.push(image ? { image } : { value: value || '' });
                        });

                        data.push(row);
                    });

                    allFormsOutput.push({
                        formName: currentForm.label,
                        formId: currentForm.value,
                        fields,
                        data,
                    });
                });

                setTables(allFormsOutput);
            }
        } catch (error) {
            toast.error(error.message);
            if (error.name === 'AbortError') {
                return;
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && form && startDate && endDate) {
            fetchData();
        }
    }, [show, form, user?.value, channel?.value, startDate, endDate]);

    return (
        <Fragment>
            <Button onClick={handleShow}>
                <IoDocuments />
                <span className="ml-2">Log Format</span>
            </Button>
            <Modal show={show} onHide={handleClose} dialogClassName="modal-90w" dialogAs={StyledModalDialog}>
                <Modal.Header closeButton className="h3 text-center">
                    <Modal.Title className="modal-headers"> Log Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isFormSelected || !startDate || !endDate ? (
                        <Fragment>
                            <div>
                                {!isFormSelected && <p>- Please select a form !</p>}
                                {!startDate && <p>- Please select a start date !</p>}
                                {!endDate && <p>- Please select a end date !</p>}
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            {loading ? (
                                <div className="text-center">
                                    <VscLoading className="spin" size={50} />
                                </div>
                            ) : (
                                <SubmissionViewer tables={tables} user={user} teamInfo={teamInfo} />
                            )}
                        </Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    position: state.user.position,
    teams: state.teams.teams,
});

export default connect(mapStateToProps, {})(AccumulatedView);
